export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://stage-api.cure.app',
};
